import React, { useState } from "react";

const calculateAge = (dateOfBirth, effectiveDate) => {
    dateOfBirth = new Date(dateOfBirth);
    effectiveDate = new Date(effectiveDate);

    let age = effectiveDate.getYear() - dateOfBirth.getYear();
    if (effectiveDate.getMonth() < dateOfBirth.getMonth() || (effectiveDate.getMonth() === dateOfBirth.getMonth() && effectiveDate.getDate() < dateOfBirth.getDate())) {
        age--;
    }

    return age;
}

export const Context = React.createContext();
export const ContextProvider = ({ children }) => {
    const defaultApplicant = { id: 0, type: 'Primary', dateOfBirth: '', sex: '', tobacco: false };
    const counties = ['Brevard', 'Flagler', 'Indian River', 'Lake', 'Orange', 'Osceola', 'Pasco', 'Polk', 'Seminole', 'Volusia', 'Hernando', 'Highlands', 'Marion', 'Sumter']

    const [applicants, _setApplicants] = useState([{ ...defaultApplicant, id: 0 }]);
    // When applicants are set, calculate their ages
    const setApplicants = (applicants) => {
        // Reset state variables
        setSelectedPlan({});
        setIsSubmitted(false);

        _setApplicants(applicants
            .map(applicant => ({ ...applicant, age: calculateAge(applicant.dateOfBirth, effectiveDate) }))
        );
    }

    const [effectiveDate, _setEffectiveDate] = useState(new Date().toLocaleDateString("sv"));
    // When the effective date changes, recalculate ages
    const setEffectiveDate = (effectiveDate) => {
        _setEffectiveDate(effectiveDate);

        _setApplicants(applicants
            .map(applicant => ({ ...applicant, age: calculateAge(applicant.dateOfBirth, effectiveDate) }))
        );
    }

    const [selectedCounty, setSelectedCounty] = useState('Brevard');

    const [selectedPlan, _setSelectedPlan] = useState({});
    const setSelectedPlan = (plan) => {
        // Reset state variables
        setIsSubmitted(false);

        // reconcile applicants
        let apps = applicants.map(applicant => {
            const rateData = plan?.applicants?.find(x => x.id === applicant.id);
            if (rateData) {
                return { ...applicant, rate: 0, ...rateData };
            }
            else {
                return { ...applicant, rate: 0 };
            }
        });
        _setApplicants(apps);

        _setSelectedPlan(plan);
    }

    // Tracks the state of the application submission
    const [isSubmitted, setIsSubmitted] = useState(false);

    return (
        <Context.Provider value={{ applicants, setApplicants, defaultApplicant, counties, effectiveDate, setEffectiveDate, selectedCounty, setSelectedCounty, selectedPlan, setSelectedPlan, isSubmitted, setIsSubmitted }}>
            {children}
        </Context.Provider>
    );
};
